"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForecastRegressorKpis = exports.ForecastRegressorLabels = exports.ForecastRegressor = void 0;
var ForecastRegressor;
(function (ForecastRegressor) {
    ForecastRegressor["CustomerBase"] = "customer-base";
    ForecastRegressor["GrossAdds"] = "gross-adds";
    ForecastRegressor["Activations"] = "activations";
    ForecastRegressor["Churn"] = "churn";
    ForecastRegressor["SalesEvents"] = "sales-events";
    // CustomerEvents = 'customer-events',
    // Adjustments = 'adjustments',
})(ForecastRegressor || (exports.ForecastRegressor = ForecastRegressor = {}));
exports.ForecastRegressorLabels = {
    [ForecastRegressor.CustomerBase]: 'Customer Base',
    [ForecastRegressor.GrossAdds]: 'Gross Adds',
    [ForecastRegressor.Churn]: 'Churn',
    [ForecastRegressor.Activations]: 'Activations',
    [ForecastRegressor.SalesEvents]: 'Sales Events',
    // [ForecastRegressor.CustomerEvents]: 'Customer Events',
    // [ForecastRegressor.Adjustments]: 'Adjustments',
};
exports.ForecastRegressorKpis = {
    [ForecastRegressor.CustomerBase]: ['Customer Base'],
    [ForecastRegressor.GrossAdds]: ['Gross Adds', 'Gross Add'],
    [ForecastRegressor.Activations]: ['Activations', 'Activation'],
    [ForecastRegressor.Churn]: ['Churn', 'Churns'],
    [ForecastRegressor.SalesEvents]: ['Sales Events', 'Sales Event'],
    // [ForecastRegressor.CustomerEvents]: ['Customer Events', 'Customer Event'],
    // [ForecastRegressor.Adjustments]: ['Adjustments', 'Adjustment'],
};
